module.exports = __webpack_public_path__ + "static/media/img8.af469c57.png";